import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, Grid2 as Grid, Link, Stack, Typography } from '@mui/material'
import { PageHeader } from '@/components/page-header'
import { routes } from '@/router'
import { INSURANCE_PRODUCTS } from './insurance.constants'
import { InsuranceProduct } from './insurance.types'
import { InsuranceCard } from './insurance-card'
import { InsuranceDetailDialog } from './insurance-detail-dialog'

export function InsurancePage() {
  const navigate = useNavigate()
  const [selectedProduct, setSelectedProduct] =
    useState<InsuranceProduct | null>(null)

  const openSimulation = (product: InsuranceProduct) => {
    if (product.simulateRoute) {
      navigate(product.simulateRoute)
      return
    }

    if (product.simulateUrl) {
      window.open(product.simulateUrl, '_blank', 'noopener,noreferrer')
    }
  }

  return (
    <>
      <PageHeader rollbackRoute={routes.menu}>Seguros</PageHeader>

      <Stack spacing={{ xs: 3, md: 4 }} pb={3}>
        <Box textAlign="center" maxWidth={700} mx="auto">
          <Typography variant="h4" component="h1" mb={1}>
            Sua proteção completa com a Porto Seguro, em um só lugar
          </Typography>
          <Typography color="text.secondary">
            Conheça as opções disponíveis e escolha a proteção que combina com o
            seu momento.
          </Typography>
        </Box>

        <Grid container spacing={2} justifyContent="center">
          {INSURANCE_PRODUCTS.map((product) => (
            <Grid key={product.id} size={{ xs: 12, sm: 6, md: 4 }}>
              <InsuranceCard
                product={product}
                onDetails={setSelectedProduct}
                onSimulate={openSimulation}
              />
            </Grid>
          ))}
        </Grid>

        <LegalFooter />
      </Stack>

      <InsuranceDetailDialog
        open={Boolean(selectedProduct)}
        product={selectedProduct}
        onClose={() => setSelectedProduct(null)}
        onSimulate={openSimulation}
      />
    </>
  )
}

function LegalFooter() {
  return (
    <Box
      component="footer"
      sx={{
        mt: 1,
        pt: 2,
        borderTop: 1,
        borderColor: 'divider',
      }}
    >
      <Stack spacing={1}>
        <Typography variant="caption" color="text.secondary">
          Seguros intermediados por{' '}
          <Box component="span" fontWeight={700}>
            ALUME CORRETORA DE SEGUROS LTDA
          </Box>
          , corretora de seguros registrada na SUSEP sob o número 262182244 e
          CNPJ 67.622.553.0001-57.
        </Typography>
        <Typography variant="caption" color="text.secondary">
          A aceitação da proposta está sujeita à análise do risco. O registro do
          produto na SUSEP não implica, por parte da Autarquia, incentivo ou
          recomendação à sua comercialização. As coberturas, exclusões,
          franquias, carências, limites e valores são os previstos na proposta e
          nas condições gerais de cada produto, apresentadas antes da
          contratação.
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Você pode consultar a situação cadastral da corretora e da seguradora
          em{' '}
          <Link
            href="https://www.susep.gov.br"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.susep.gov.br
          </Link>
          .
        </Typography>
        <Typography variant="caption" color="text.secondary">
          Porto Seguro Cia. de Seguros Gerais — CNPJ 61.198.164/0001-60, e
          demais seguradoras do grupo Porto, conforme o produto.
        </Typography>
      </Stack>
    </Box>
  )
}
